// extracted by mini-css-extract-plugin
export default {"page":"Layout_page__Pg1Bx"};